import { render, staticRenderFns } from "./FeedbackSearch.vue?vue&type=template&id=5875294c&scoped=true&"
import script from "./FeedbackSearch.vue?vue&type=script&lang=js&"
export * from "./FeedbackSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875294c",
  null
  
)

export default component.exports